import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

function Login() {
  const navigate = useNavigate();

  // 🔹 Liste der Testpersonen
  const validUsers = Array.from({ length: 10 }, (_, i) => `Testperson${i + 1}`);
  const validPassword = '1234';

  // 🔹 Lokaler State für Eingaben und Fehlermeldungen
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // 🔹 Login-Prüfung (lokal)
  const handleLogin = e => {
    e.preventDefault();

    if (validUsers.includes(username) && password === validPassword) {
      console.log(`Login erfolgreich: ${username}`);
      localStorage.setItem('loggedInUser', username); // Benutzer lokal speichern
      navigate('/'); // Weiterleitung zur Startseite oder App-Hauptseite
    } else {
      setErrorMessage('Benutzername oder Passwort falsch');
    }
  };

  return (
    <div className="login-wrapper"
    style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + '/img/bg-login.svg'})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        width: '100%',
      }}>

  {/* Login-Karte */}
  <div className="login-card">
    <form onSubmit={handleLogin} className="login-form">
      <label htmlFor="username">Benutzername:</label>
      <input
        id="username"
        type="text"
        value={username}
        onChange={e => setUsername(e.target.value)}
        placeholder="z. B. Testperson1"
      />

      <label htmlFor="password">Passwort:</label>
      <input
        id="password"
        type="password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        placeholder="Passwort"
      />
    </form>

    {errorMessage && <p className="error">{errorMessage}</p>}

  </div>

  {/* 🔹 Login-Button außerhalb der Karte */}
  <button onClick={handleLogin} className="main-btn login-btn outside-btn">Einloggen</button>

</div>
  );
}

export default Login;